import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from 'ducks/currentUser/selectors/selectCurrentUser'
import { isEmpty } from 'util/objects'
import useAccountFeatureFlag from 'util/hooks/useAccountFeatureFlag'
import { selectCurrentBillingCycle } from 'ducks/billing/selectors/selectCurrentBillingCycle'

const useOpenContact = ({ left } = {}) => {
  const currentUser = useSelector(selectCurrentUser)
  const billingCycle = useSelector(selectCurrentBillingCycle)
  const isHelplyAgentReady = useAccountFeatureFlag('helply-agent-ready')

  const openContact = useCallback(
    async e => {
      if (isHelplyAgentReady && window.helplyAgentWidget) {
        if (!isEmpty(currentUser)) {
          window.helplyAgentWidget.setContact({
            email: currentUser.email,
            firstName: currentUser.first_name,
            lastName: currentUser.last_name,
          })

          window.helplyAgentWidget.identify({
            token: currentUser.helplyIdentifyToken,
            user_metadata: {
              'Unified-Inbox': currentUser.preferences.unified_inbox,
              'Billing-Cycle': billingCycle,
            },
          })
        }
        window.helplyAgentWidget.open()
        if (e?.preventDefault) {
          e.preventDefault()
        }

        return
      }
      if (!window.groove?.widget) return
      if (e?.preventDefault) {
        e.preventDefault()
      }

      if (left) {
        await window.groove.widget.updateSettings({
          iconPosition: 'left',
        })
      }
      window.groove.widget.pushRoute('/contact')
      window.groove.widget.open()
      if (!isEmpty(currentUser)) {
        window.groove.widget.identifyContact('contact_email', currentUser.email)
        window.groove.widget.setContact({
          contact_first_name: currentUser.first_name,
          contact_last_name: currentUser.last_name,
        })
      }
    },
    [currentUser, left, isHelplyAgentReady, billingCycle]
  )

  return openContact
}

export default useOpenContact
